import { Title } from '@inflearn/ds-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import MyPageLayout from '../../../../components/layout/MyPageLayout';
import { SettingsPageTabs } from '../../../../components/pages/my/settings/SettingsPageTabs/SettingsPageTabs';

export function SettingLayout({
  children,
  title,
  description,
  pageCategory,
}: {
  children: ReactNode;
  title: string;
  description: string;
  pageCategory?: string;
}) {
  const { t } = useTranslation();

  return (
    <MyPageLayout
      meta={{
        title,
        description,
        pageCategory,
      }}
    >
      <Title order={1} size="h2" mb={8}>
        {t('설정')}
      </Title>
      <SettingsPageTabs />
      {children}
    </MyPageLayout>
  );
}
